<template>
    <div class="totalBox">
        <div class="item">
            <span class="label">合计：</span>
            <span class="val red big-text">¥ {{allTotalPrice ? allTotalPrice : "0.00"}}</span>
        </div>
        <div class="item">
            <input type="hidden" name="password" value="">
            <el-button class="totalBtn" @click="clearContent">&nbsp;&nbsp;清空&nbsp;&nbsp;</el-button>
            <el-button class="totalBtn" @click="saveTmpOrder">&nbsp;&nbsp;挂单&nbsp;&nbsp;</el-button>
            <el-button type="primary" class="totalBtn" @click="totalEvent">&nbsp;&nbsp;结账&nbsp;&nbsp;</el-button>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import TotalDone from "@/model/Cash/TotalDone";
    import CashTotalBox from "@/model/Cash/CashTotalBox";
    export default {
        name: "PayTotal",
        components: {CashTotalBox, TotalDone},
        data: () => ({
            allProPrice: 0,
            allTotalPrice: 0,
            payType: {
                value: 4,
                options: [
                    { label: "余额", value: 1},
                    { label: "微信", value: 2},
                    { label: "支付宝", value: 3},
                    { label: "现金", value: 4},
                    { label: "银联卡", value: 5}
                ]
            },
            orderData: {}
        }),
        props: {
            orderList: {
                type: Array,
                default: []
            },
            orderIndex: {
                type: Number,
                default: 0
            },
            orderOption: Object
        },
        mounted: function(){
            this.syncOrderData();
        },
        methods: {
            //同步结算信息
            syncOrderData: function () {
                if(!obj.isEmpty(this.orderList[this.orderIndex]))
                    this.orderData = this.orderList[this.orderIndex];
                else {
                    this.allTotalPrice = 0;
                }
            },
            //结算
            totalEvent: function () {
                //检查订单编号是否必填
                if(this.orderOption.requiredOrderNo && obj.isEmpty(this.orderData.order_no)){
                    obj.message.error("请输入单号");
                    return false;
                }

                let settleData = [{
                    tmp_id: this.orderData.tmp_id,
                    order_key: this.orderIndex,
                    order_date: this.orderData.order_date ? this.orderData.order_date : "",
                    order_no: this.orderData.order_no,
                    allTotalPrice: this.allTotalPrice,
                    pro_list: this.orderData.pro_list,
                    cash_mode: 1,
                }];
                this.$emit("settle", settleData);
            },
            //清除数据
            clearContent: function () {
                this.allProPrice = "0.00";
                this.allTotalPrice = "0.00";
                this.$emit("clearProduct");
            },

            //计算总价
            settleTotalPrice: function () {
                let allProPrice = 0;
                let allTotalPrice = 0;
                this.orderData.pro_list.forEach(v => {
                    v.price = parseFloat(v.price);
                    v.num = parseFloat(v.num);
                    v.total_price = parseFloat(v.total_price);

                    allProPrice += v.price * v.num;
                    allTotalPrice += v.total_price;
                });

                this.allProPrice = allProPrice;
                this.allTotalPrice = allTotalPrice;
            },

            //挂单
            saveTmpOrder: function () {
                //检查是否选择了会员
                if(!obj.isEmpty(this.orderData.userInfo)) {
                    obj.message.error("请清除会员，再挂单");
                    return false;
                }

                //判断是否添加消费项目
                if(obj.isEmpty(this.orderData.pro_list)){
                    obj.message.error("请添加消费项目");
                    return ;
                }

                //检查订单编号是否必填
                if(this.orderOption.requiredOrderNo && obj.isEmpty(this.orderData.order_no)){
                    obj.message.error("请输入单号");
                    return false;
                }

                this.postTmpOrder();
            },

            //提交挂单
            postTmpOrder: function () {
                obj.messageBox.confirm("您确定要挂单吗？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info',
                    showClose: false,
                }).then( () => {
                    let tmpOrderData = {
                        tmp_id: this.orderData.tmp_id,
                        order_no: this.orderData.order_no,
                        pro_data: JSON.stringify(this.orderData.pro_list),
                    };

                    obj.postData("tmp_order/save_tmp_order", tmpOrderData, res => {
                        if(res.errcode === 0){
                            obj.message.success("挂单成功");
                            this.$emit("saveTmpOrder");
                        }else{
                            obj.message.error(res.errdesc);
                        }
                    });
                }, () => {});
            }
        },
        watch: {
            "orderList": function () {
                this.syncOrderData();
            },
            "orderIndex": function () {
                this.syncOrderData();
            },
            "orderData.pro_list": function (data) {
                this.settleTotalPrice();
            },
            "allProPrice": function (newData) {
                this.allProPrice = parseFloat(newData).toFixed(2);
            },
            "allTotalPrice": function (newData) {
                this.allTotalPrice = parseFloat(newData).toFixed(2);
            }
        }
    }
</script>

<style scoped>
    .totalBox{
        text-align: right;
    }
    .totalBox>.item{
        display: inline-block;
        margin-left: 30px;
    }
    .totalBox>.item .underline {
        border: none;
        border-bottom: 1px solid #b6b6b6;
        background: none;
        text-align: left;
        width: 80px;
        padding: 3px 10px;
        margin: 0px 5px;
    }
    .totalBox>.item .pay_type {
        border: none;
        background: none;
        margin-right: 10px;
    }
    /*.totalBtn{*/
        /*background-color: #2e6afe;*/
        /*border-color: #2e6afe;*/
    /*}*/
    .big-text{
        font-size: 28px;
        font-weight: bold;
    }
    .totalBtn{
        padding-left: 22px;
        padding-right: 22px;
    }
</style>
